module.exports = __webpack_public_path__ + "img/11_non_close_L1.9a534908.svg";